/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type OtaAccommodationMetrics_OtaAccommodationMetricsUpdate_jsonld_metrics_read = {
    readonly '@context'?: string | Record<string, any>;
    readonly '@id'?: string;
    readonly '@type'?: string;
    accommodationId?: string;
    listingId?: string;
    listingType?: OtaAccommodationMetrics_OtaAccommodationMetricsUpdate_jsonld_metrics_read.listingType;
};
export namespace OtaAccommodationMetrics_OtaAccommodationMetricsUpdate_jsonld_metrics_read {
    export enum listingType {
        COUNTRY = 'country',
        CITY = 'city',
        REGION = 'region',
        LEGACY_COUNTRY = 'legacy_country',
        LEGACY_VOIDESHIP = 'legacy_voideship',
        LEGACY_CITY = 'legacy_city',
        LEGACY_REGION = 'legacy_region',
    }
}
